import { ModalHandler } from '@app-velocity/ui';

import { EULAModalContent } from './components/EULAModalContent';

export const EULAModal = () => {
  return (
    <ModalHandler
      id="eula"
      channel="users"
    >
      <EULAModalContent />
    </ModalHandler>
  );
};
